import type { SVGProps } from 'react';

export const SvgIconCategory250 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={33} height={33} viewBox="0 0 33 33" fill="none" {...props}>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M27.375 9.043h-22a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-15a1 1 0 0 0-1-1M10.375 3.043l6 6 6-6"
    />
    <path
      fill="#000"
      d="M23.875 16.043a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M23.875 22.043a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
    <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.375 26.043v-17" />
  </svg>
);
